<template lang="pug">
  v-container
    v-row
      v-text-field(v-model='search' prepend-icon='fa-search' label='Buscar' single-line hide-details)
      dataPickerCombobox(type='Inputs')
    v-row
      v-col
        v-data-table.elevation-1(
          :headers="headers" 
          :items="inputsRecord"
          :search='search'
          :options.sync="options" 
          :loading='Inputs.loading' 
          :footer-props="footerProps"
          show-select
          item-key="numero_de_operacion"
          :server-items-length='Inputs.cantidad_de_registros'
          v-model="elementos_seleccionados"
        )
          template( v-slot:top )
            v-toolbar( flat color="white")
              v-toolbar-title Notas de Entrada
              v-spacer
              MassiveInputDialog
              Formulario_maestro(modelo='Inputs')
          
          template( v-slot:item.estado_del_documento="{item}")
            Botones(:estado_del_documento = 'item.estado_del_documento' :id = 'item.id' )
          template( v-slot:item.total = '{item}')
            v-chip(v-if='item.total') {{ Number(item.total).toFixed(2) }}
          template( v-slot:item.comprobante_serie_numero = '{item}')
            v-chip(small v-if='item.comprobante_serie_numero') {{ item.comprobante_serie_numero }}
    v-row
      v-col
        v-btn.mt-3(@click='proceso_masivo({elementos_seleccionados, tipo_de_operacion:"entrada" })' :disabled='elementos_seleccionados.length==0' rounded color='primary') Proceso Masivo
        printerButtons(:dataToPrint = 'inputsRecord')
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  data: ()=>({
    search: '',
    headers: [
      { text: 'Nº',           value: 'numero_de_operacion' },
      { text: 'Operación',       value: 'nombre_motivo_de_traslado' },
      { text: 'Proveedor',    value: 'proveedor_denominacion' },
      { text: 'Fecha',        value: 'fecha_de_emision' },
      { text: 'Monto',        value: 'total' },
      { text: 'Comprobante',  value: 'comprobante_serie_numero' },
      { text: '',  value: 'estado_del_documento' },
    ],
    footerProps: {
      'items-per-page-options':   [15, 50, 250]
    },
    options: {},
    elementos_seleccionados: [],
 
  }),
  methods:{
    ...mapActions({
      obtener_todo: 'Inputs/obtener_todo',
      proceso_masivo: 'Kardex/proceso_masivo'
    }), 
  },
  computed:{
    ...mapGetters({
      inputsRecord: 'Inputs/registro',
    }),
    ...mapState({
      Inputs: state => state.Inputs,
      db_activada: state=>state.Customers.db_activada,
    }),
  },
   watch:{
    'db_activada'(){
      this.obtener_todo({itemsPerPage: 15, page: 1})         
    },
    options: {
      handler () {
        this.obtener_todo(this.options)
      },
      deep: true,
    },
  },
  components: {
    MassiveInputDialog: () => import('.././componentes/massiveInputDialog'),
    Formulario_maestro: () => import('@/components/formulario_maestro'),
    dataPickerCombobox: ()=>import('.././componentes/dataPickerCombobox'),
    printerButtons: ()=>import('.././componentes/printerButtons'),
    Botones: () => import('.././componentes/Botones'),
    
  }
}
</script>
